var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("term.drillList"))),
    ]),
    _vm._v(" "),
    _vm.drills.length > 0
      ? _c(
          "ul",
          _vm._l(_vm.drills, function (drill) {
            return _c("li", { staticClass: "block" }, [
              _c(
                "div",
                { staticClass: "mt-3" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "is-size-5 has-text-weight-semibold",
                      attrs: { to: `/user/drills/${drill.drillId}` },
                    },
                    [_vm._v(_vm._s(drill.drillId))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2" }, [
                _c("label", { staticClass: "has-text-weight-semibold" }, [
                  _vm._v(_vm._s(_vm.$t("term.service"))),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(drill.serviceLabel))]),
                _vm._v(" "),
                _c("span", [_vm._v("(" + _vm._s(drill.serviceId) + ")")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2" }, [
                _c("label", { staticClass: "has-text-weight-semibold" }, [
                  _vm._v(_vm._s(_vm.$t("term.startedAt"))),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm._f("dateFormat")(drill.startedAt))),
                ]),
              ]),
            ])
          }),
          0
        )
      : _vm.isLoading !== false
      ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.$t('msg["Data is empty"]')))])])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }